import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'

import FavoriteButtonComponent from './component'

export const allTournamentsFavorite = combine(
  withTableController({ id: 'athlete-table' }),
  withContext('appStore', StoreContext),
  withContext(
    'followerService',
    ServicesContext,
    ({ followerService }) => followerService
  ),
  withCallback(
    'onFavoriteButton',
    ({ followerService, table }, { value }) =>
      () => {
        if (!value.followed) {
          followerService
            .addFollowers({
              tournamentIds: [value.id],
            })
            .then(() => table.refresh())
        } else {
          followerService
            .removeFollowers({ tournamentIds: [value.id] })
            .then(() => table.refresh())
        }
      },
    ['value']
  )
)(FavoriteButtonComponent)
